import React from "react";
import { useSelector } from "react-redux";
import { Box } from "@mui/material";
import SideNav from "../../../components/commonComponents/Sidebar/SideNav";
import {
  StyledMainBox,
  StickyTopRowStackSpaceBetween,
} from "../../../components/commonComponents/StyledComponents/styled";
import TableauDash from "../../../components/commonComponents/TableauDashboard/TableauDash";
import { checkUserDetailsFromCookie } from "../../../api_calls/userManagement";
import Grid from "@mui/material/Unstable_Grid2";
import { clearfilters } from "../../../api_calls/campaignRequests";
import { TextButton } from "../../../components/commonComponents/Buttons/ActionButton";
import { useNavigate } from "react-router-dom";
import {
  formatToStandardDate,
  standardFormatToday,
  getFirstDayTwoMonthsAgo,
  findStoreIds,
  independentStoreListOptions,
  findEmbeddableId,
} from "../../../api_calls/utils";
import StoreFilter from "../../../components/commonComponents/Filters/StoreFilter";
import VisualNameFilter from "../../../components/commonComponents/Filters/VisualNameFilter";
import { fetchPicNames, loadPictures } from "../../../api_calls/pictureRequests";
import Dashboard from "../../../components/commonComponents/Embeddable/Dashboard";
import { fetchLoopNames, fetchVisualNames } from "../../../api_calls/loopCampaign";

const LoopOverview = () => {
  // Variables
  const userStateDate = useSelector((state) => state.userSelections);
  const [userInfo, setUserInfo] = React.useState({});
  const [visualLoaded, setVisualLoaded] = React.useState(false);

  const navigate = useNavigate();

  const dashboardVariables = () => {
    let overviewDashboardVariables = {}

    if (typeof userStateDate.embedded_picture_overview_picture_selection !== "undefined" && userStateDate.embedded_picture_overview_picture_selection.length !== 0) {
      overviewDashboardVariables = {
        ...overviewDashboardVariables,
        IdPicture: userStateDate.embedded_picture_overview_picture_selection,
      }
    }
    if (typeof userStateDate.embedded_picture_overview_stores !== "undefined" && userStateDate.embedded_picture_overview_stores.store_ids.length !== 0) {
      overviewDashboardVariables = {
        ...overviewDashboardVariables,
        Stores: userStateDate.embedded_picture_overview_stores.store_ids,
      }
    }

    return overviewDashboardVariables;
  }

  React.useEffect(() => {
    const checkUserDetails = checkUserDetailsFromCookie();

    let userDetailObj = {};
    if (checkUserDetails.success === true) {
      userDetailObj = checkUserDetails.user_detail;
    }
    setUserInfo(userDetailObj);
    const fetchData = async () => {
      await fetchVisualNames();
      setVisualLoaded(true);
    };
    fetchData();
    clearfilters();
  }, []);

  // Elements
  return (
    <Box sx={{ display: "flex" }}>
      <SideNav />
      {typeof userStateDate.visual_names_info !== "undefined" && typeof userStateDate.visual_names_info !== "undefined" ? (
        <StyledMainBox component="main">
          <StickyTopRowStackSpaceBetween direction={"row"} spacing={2}>
            {/* ------- Back to campaigns button ----------- */}
            <Box sx={{ alignContent: "center" }}>
              <TextButton
                onClick={(e) => {
                  // e.preventDefault();
                  navigate("/check-campaigns/loop-based-campaigns");
                }}
                label={"Back to Loop-based Campaigns"}
              />
            </Box>
            <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "flex-end" }}>
              <Box sx={{ width: 250 }}>
                {/* ------- Clip Name/ clips boolean Filter ----------- */}
                {
                  visualLoaded && (
                    <VisualNameFilter usedFor={"picture"} reduxKeywordToSaveValue={"embedded_picture_overview_picture_selection"} />
                  )
                }

              </Box>
              <Box sx={{ width: 250 }}>
                {/* ------- Campaign Name Filter ----------- */}
                <StoreFilter
                  usedFor={"overview"}
                  reduxKeywordToSaveValue={"embedded_picture_overview_stores"}
                  fetchListFor="independent"
                />
              </Box>
            </Box>
          </StickyTopRowStackSpaceBetween>
          <Box height={1} />
          <Grid container spacing={2}>

            {typeof userInfo.root_company_id !== "undefined" && userInfo.root_company_id !== "" && typeof userStateDate.stores_list !== "undefined" && (
              <Dashboard
                embedDashboardId={findEmbeddableId("brand_analytics", "loop_overview")}
                variables={dashboardVariables()}
                filterConfig={{
                  "number_root": userInfo.root_company_id.toString(),
                }} />
            )}
          </Grid>
        </StyledMainBox>
      ) : (
        <Box>
          {typeof userStateDate.loading !== "undefined" && userStateDate.loading === true ? (
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <StyledMainBox component="main">
                <p>Loading Results</p>
              </StyledMainBox>
            </Box>
          ) : (
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <StyledMainBox component="main">
                {typeof userStateDate.clips_list !== "undefined" ? <p>No clips found...</p> : ""}
              </StyledMainBox>
            </Box>
          )}
        </Box>
      )}
    </Box>
  );
};
export default LoopOverview;